import { BaseEntity } from 'yt-ng-framework';

export class Zanimanje extends BaseEntity {
    constructor(){
        super();
    }
    Naziv: string = null;
    Sifra: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Sifra = input.Sifra;
        return this;
    }

    Serialize(input: Zanimanje){
        return input;
    }
}
